import { Filters } from "../../common/generators/filters";
import {
  FilterInput,
  BaseFiltersInput,
  UserFiltersInput,
  UserItem
} from "@core/store/types/common/statistic/generic/statisticFilters";
import { LandingsService } from "@core/services/common/lists/LandingService";

export class LandingFilters extends Filters<UserItem, BaseFiltersInput> {
  getData = async (offset: number, limit: number, filters: UserFiltersInput, initialFilters: BaseFiltersInput) => {
    const { data: { landingPages, initialLandings } } =
            await LandingsService.getLandingFilters(offset, limit, initialFilters, filters);

    return {
      data: {
        items: landingPages.items,
        count: landingPages.count
      },
      initialData: {
        items: initialLandings?.items,
        count: initialLandings?.length
      }
    };
  }

  getInitialFilters = (ids?: Array<string> | string): FilterInput | undefined => {
    if (ids) {
      const id = Array.isArray(ids) ? ids : [ids];
      return { id };
    }
  };
}
